// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"ee50ab1f","239":"9f05c4c2","311":"e1d885e6","455":"fe17a070","970":"d5fadfe8","977":"0216a576"}[chunkId] + ".chunk.js";
};